import { Center, CloseButton } from '@mantine/core';
import * as React from 'react';
import { useHover } from '@mantine/hooks';

type props = {
  onDelete: () => void;
};

const StepFieldsRemoveButton = ({ onDelete }: props) => {
  const { hovered, ref: hoverRef } = useHover();

  return (
    <Center h={'36px'} mt={'28px'}>
      <CloseButton
        onClick={() => onDelete()}
        ref={hoverRef}
        style={{
          background: hovered ? '#inherit' : 'inherit',
          color: hovered ? '#9E9E9E' : '#BABABA',
        }}
        size={'sm'}
      />
    </Center>
  );
};

export default StepFieldsRemoveButton;
